import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 24,
  label: "省市主要申请人分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "applicantProvince", label: "省", needTotal: true }],
    colDims: [
      {
        name: "applicantNewName",
        label: "申请人",
        table: "patent_applicant",
        limit: 10,
        needTotal: true,
      },
    ],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    condition: {
      items: [
        {
          name: "applicantProvince",
          operator: "NOT_NULL",
        },
      ],
    },
    showNoDataDims: true,
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "省市主要申请人分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
